module.exports = __webpack_public_path__ + "static/media/SuccessService.2b56b792.svg";